import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app/storeApp'
import rsvp from './modules/rsvp/storeRsvp'
import domain from './modules/domain/storeDomain'
import wallet from './modules/wallet/storeWallet'
import invites from './modules/invites/storeInvites'
import onboardingCreateSite from './modules/onboarding/storeOnboarding'
import theme from './modules/theme/storeTheme'
import gifts from './modules/gifts/storeGifts'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    rsvp,
    domain,
    wallet,
    invites,
    onboardingCreateSite,
    theme,
    gifts,
  },
})
